export class GlobalAdminProjectsManager {
    constructor(globalAdminProjectsService) {
        this.globalAdminProjectsService = globalAdminProjectsService;
    }
    async listProjects(organizationId) {
        return this.globalAdminProjectsService.listProjects(organizationId);
    }
    async listProjectOwners(organizationId) {
        return this.globalAdminProjectsService.listProjectOwners(organizationId);
    }
    async createProject(organizationId, input) {
        return this.globalAdminProjectsService.createProject(organizationId, input);
    }
    async getProject(organizationId, projectId, versionInput) {
        return this.globalAdminProjectsService.getProject(organizationId, projectId, versionInput);
    }
    async updateProjectDraft(organizationId, projectId, update) {
        return this.globalAdminProjectsService.updateProjectDraft(organizationId, projectId, update);
    }
    async getProjectDraftVersionNumber(organizationId, projectId) {
        return this.globalAdminProjectsService.getProjectDraftVersionNumber(organizationId, projectId);
    }
    async createProjectDraftIfNecessary(organizationId, projectId) {
        return this.globalAdminProjectsService.createProjectDraftIfNecessary(organizationId, projectId);
    }
    async getOrgIconUrl(organizationId, projectId, file) {
        return this.globalAdminProjectsService.getOrgIconUrl(organizationId, projectId, file);
    }
    async getOrgRectangularIconUrl(organizationId, projectId, file) {
        return this.globalAdminProjectsService.getOrgRectangularIconUrl(organizationId, projectId, file);
    }
    async deleteProjectDraft(organizationId, projectId) {
        return this.globalAdminProjectsService.deleteProjectDraft(organizationId, projectId);
    }
    async listProjectUsers(organizationId, projectId) {
        return this.globalAdminProjectsService.listProjectUsers(organizationId, projectId);
    }
    async addProjectUser(organizationId, projectId, userId, input) {
        return this.globalAdminProjectsService.addProjectUser(organizationId, projectId, userId, input);
    }
    async removeProjectUser(organizationId, projectId, userId) {
        return this.globalAdminProjectsService.removeProjectUser(organizationId, projectId, userId);
    }
}
